import { useCallback } from "react";

import type { ReservationCancelFeeChargeInput } from "@/lib/gql/__generated__/graphql";

import * as MutationRepository from "../../repository/mutation";

export const useUpdateReservationDetailChargeCancelFee = (hotelID: string, reservationID: string) => {
	const { onChargeCancelFee: _onChargeCancelFee } = MutationRepository.useReservationDetailCancelFeeChargeMutation();

	/**
	 * キャンセル料の請求を実行
	 */
	const onChargeCancelFee = useCallback(
		async (chargePrice: ReservationCancelFeeChargeInput["chargePrice"]) => {
			const input: ReservationCancelFeeChargeInput = {
				hotelID,
				reservationID,
				chargePrice,
			} satisfies ReservationCancelFeeChargeInput;
			await _onChargeCancelFee(input);
		},
		[_onChargeCancelFee, hotelID, reservationID],
	);

	return {
		onChargeCancelFee,
	};
};
